export default __webpack_public_path__ + "751d4a20115f20de27ac1cece5c71bfa.png";